import React from 'react';
import styled from 'styled-components';
import ContributorsFilterContext from './context';

const Container = styled.div`
  width: 100%;
  padding: 0 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &:after {
    order: 0;
    content: "";
    border: 0;
    height: 14px;
    margin: 0 4px;
    border-right: 1px solid ${props => props.theme.secondaryColor30Transparent};
  }

  & > button {
    font: ${props => props.theme.fontWeightHeavy} 16px/30px ${props => props.theme.fontFamilyBody};
    border: none;
    background-color: transparent;
    outline: none;
    text-transform: capitalize;
    color: ${props => props.theme.primaryColor};
  }

  & > button[disabled] {
    color: ${props => props.theme.secondaryColor30Transparent};
  }

  & > button:first-child {
    order: -1;
  }

  & > button:last-child {
    order: 1;
  }
`;

export default function Actions() {
  const { state, dispatch } = React.useContext(ContributorsFilterContext);

  const toggle = v => e => {
    e && e.preventDefault();
    dispatch({ type: 'toggleAll', payload: v });
  };

  return (
    <Container>
      <button type="button" disabled={state.allSelected} onClick={toggle(true)}>select all</button>
      <button type="button" disabled={state.noneSelected} onClick={toggle(false)}>clear</button>
    </Container>
  );
}
